import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { getToken, setToken, removeToken } from '@/assets/js/auth'
import { Notify } from 'vant';


// create an axios instance
const service = axios.create({
	baseURL:"",
	// baseURL: process.env.NODE_ENV === 'production' ? '//shop.mengchaxun.com' : '//uwigb.mynatapp.cc',
	// baseURL: '//uwigb.mynatapp.cc',
	// baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
	// withCredentials: true, // send cookies when cross-domain requests
	timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
	config => {
		try{
			let shop_id = router.history.current.params.shopid;
			if(shop_id) {
				if( !(config['data'] && config['data'].indexOf('shop_id=') != -1)) {
					if(config['data']) {
						config['data'] += '&shop_id=' + shop_id;
					}else {
						config['data'] = 'shop_id=' + shop_id;
					}
				}
			}
		}catch(e){}
		let token = getToken();
		let addToken = false;
		console.log(config['data']);
		if(config['data'] && config['data'].indexOf('islogin=1') != -1) {
			addToken = true;
		}
		if (token && addToken) {
			config.headers['Authorization'] =  'Bearer ' + token;
		}
		return config
	},
	error => {
		// do something with request error
		console.log(error) // for debug
		return Promise.reject(error)
	}
)

// response interceptor
service.interceptors.response.use(
	/**
	 * If you want to get http information such as headers or status
	 * Please return  response => response
	*/

	/**
	 * Determine the request status by custom code
	 * Here is just an example
	 * You can also judge the status by HTTP Status Code
	 */
	response => {
		const res = response.data;
		if(res.isCloseShop) {
			router.replace({name:'404', params:{message: res.message}});
			return Promise.reject(res)
		}
		if(res.token) {
			return res;
		}
		if(res.data && res.data.status == 403) {
			// token过期失效
			store.dispatch('user/resetToken');
	  		Notify({ type: 'warning', message: '登录失效' });
			router.replace({path:'/' + store.getters.shop.shop_key});
      		// this.$router.push(`/login?redirect=${this.$route.fullPath}`)
			return;
		}
		if(res.state) {
			// if(res.data && res.data['_wpnonce']) {
				// setToken(res.data['_wpnonce']);
				// store.commit('SET_TOKEN', res.data['_wpnonce']);
			// }
			return res;
		}else {
			return Promise.reject(res)
		}
	},
	error => {
		try{
			if(error.response.data.data.status == 403) {
				// console.log(error);
				store.dispatch('user/resetToken');
		  		Notify({ type: 'warning', message: '登录失效' });
				router.replace({path:'/' + store.getters.shop.shop_key});
				// router.replace({path:'/'});
				return;
			}
		}catch(e){}
		console.log('err' + error) // for debug
	  	Notify({ type: 'warning', message:  error.message });
		return Promise.reject(error)
	}
)

export default service



// WEBPACK FOOTER //
// ./src/assets/js/request.js